<template>
  <section>
    <slot />
  </section>
</template>

<script setup></script>

<style lang="scss" scoped>
section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
}
</style>
